@use "~theme/typography";
@use "~theme/breakpoints";

.header {
  display: grid;
  padding: 16px 16px 8px;
  gap: 16px;
  grid-template-columns: 48px 1fr;

  @include breakpoints.desktop {
    padding: 16px 0 8px;
  }
}

.headerIcon {
  width: 100%;
}

.headline {
  @include typography.heading3;

  margin: 0;
  color: var(--blue-01);
}

.subhead {
  @include typography.body-large;

  margin: 8px 0 0;
}

.stack {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: var(--max-desktop-width);

  > :not(:last-child) {
    margin-bottom: 24px;
  }
}

.cta {
  max-width: 475px;
  margin: 0 auto;
}
